var initHeaderSearch = function initHeaderSearch() {
  var searchButton = document.querySelector("#search-toggle-js");
  var searchForm = document.querySelector("#search-form-js");
  if (!searchButton) {
    return;
  }
  searchButton.addEventListener("click", function () {
    searchButton.classList.toggle("active");
    searchForm.classList.toggle("active");
  });
};
export { initHeaderSearch };